import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';

import './header.css';
import circleloopLogo from './cl-logo.svg';

export default class Header extends PureComponent{
    onSignIn=()=>{
        this.context.router.history.push('/');
    }
    onLogout=()=>{
        this.props.logout();
        this.context.router.history.push('/');
    }
    render(){
        const { loggedIn, authFromMobile, authoriseFlow, clientName, userName } = this.props;
        const showSignIn = !loggedIn;
        const showSignOut = loggedIn && !authFromMobile && !authoriseFlow;
        return (
            <header>
                <div className="sticky-header">
                    <div className="header-content">
                        <img src={circleloopLogo} alt='CircleLoop logo' width="165"/>
                        <div className="loggedin-content">
                            {showSignOut && userName && clientName ?
                                <div className="signin">
                                    <p className="signed-in">Signed in as:</p>
                                    <p>{`${clientName} / ${userName}`}</p>
                                </div>
                            : null}
                            {showSignIn || showSignOut ? 
                                <Button onClick={showSignIn ? this.onSignIn : this.onLogout} styling="apps-signin">{showSignIn ? 'Sign In' : 'Sign Out'}</Button>
                            : null}
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}

Header.propTypes = {
    loggedIn:PropTypes.bool,
    logout:PropTypes.func,
    userName: PropTypes.string,
    clientName: PropTypes.string,
}

Header.contextTypes = {
    router:PropTypes.object
}


// WEBPACK FOOTER //
// ./src/components/Header/index.js